import { render, staticRenderFns } from "./paid-outside-view.vue?vue&type=template&id=640e28f0&"
import script from "./paid-outside-view.vue?vue&type=script&lang=js&"
export * from "./paid-outside-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports